import React from 'react';
import PropTypes from 'prop-types';


function NoContentDisclaimer(props) {
  const { anchorName, showDisclaimer } = props;

  if (!showDisclaimer) {
    return null;
  }

  return (
    <div className="purchased-tab flex">
      <div>
        <h3>There&apos;s nothing else available around here at the moment!</h3>
        <h4>
          {`Let ${anchorName} know that you're looking forward to purchasing 
          more exclusive content or come back later to see what's new in store!`}
        </h4>
      </div>
    </div>
  );
}

export default NoContentDisclaimer;

NoContentDisclaimer.propTypes = {
  anchorName: PropTypes.string.isRequired,
  showDisclaimer: PropTypes.bool.isRequired,
};


